"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
const LineItem_1 = __importDefault(require("./LineItem"));
const storefront_1 = require("../../lib/storefront");
const GiftNoteOptions_1 = __importDefault(require("./GiftNoteOptions"));
const __1 = require("../..");
const StandardLineItemDetails_1 = __importDefault(require("./StandardLineItemDetails"));
require("./StandardLineItem.css");
(0, client_1.gql) `
  fragment StorefrontCheckoutLineItemHeavy on StorefrontCheckoutLineItem {
    id
    title
    quantity
    unitPrice {
      amount
      currencyCode
    }
    customAttributes {
      key
      value
    }
    discountAllocations {
      ...StorefrontDiscountAllocation
    }

    variant {
      id
      title
      sku
      priceV2 {
        amount
        currencyCode
      }
      selectedOptions {
        name
        value
      }
      image {
        originalSrc
        transformedSrc(maxWidth: 512, crop: CENTER)
      }
      product {
        id
        handle
        tblProductType: metafield(namespace: "tbl", key: "productType") {
          key
          value
        }
      }
    }
  }
`;
function StandardLineItem({ lineItem, DetailsComponent = StandardLineItemDetails_1.default, }) {
    var _a, _b, _c;
    const checkoutId = (0, __1.useStorefrontCheckoutId)();
    const { gotoProduct } = (0, __1.useMapmakerAppConfig)();
    const [updateCheckoutLineItems, { loading: updateLoading },] = (0, MapmakerApi_1.useStorefrontUpdateCheckoutLineItemsMutation)();
    function onSetQuantity(e) {
        return __awaiter(this, void 0, void 0, function* () {
            yield updateCheckoutLineItems({
                variables: {
                    checkoutId: checkoutId,
                    lineItems: [
                        {
                            id: lineItem.id,
                            quantity: parseInt(e.target.value) || lineItem.quantity,
                        },
                    ],
                },
            });
        });
    }
    return ((0, jsx_runtime_1.jsx)(LineItem_1.default, Object.assign({ title: lineItem.title, onProductNameClick: () => gotoProduct(lineItem.variant.product.handle), thumbnail: (_b = (_a = lineItem.variant) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.transformedSrc, price: (0, storefront_1.multiplyMoneyV2)((_c = lineItem.variant) === null || _c === void 0 ? void 0 : _c.priceV2, lineItem.quantity), lineItemIds: [lineItem.id], loading: updateLoading, discountAllocations: lineItem.discountAllocations }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "standard-line-item" }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { children: "Qty" }), (0, jsx_runtime_1.jsx)("select", Object.assign({ value: lineItem.quantity, onChange: onSetQuantity }, { children: Array(25)
                                .fill(0)
                                .map((_, i) => {
                                const qty = i + 1;
                                return ((0, jsx_runtime_1.jsx)("option", Object.assign({ value: qty }, { children: qty }), qty));
                            }) }))] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "details" }, { children: (0, jsx_runtime_1.jsx)(DetailsComponent, { lineItem: lineItem }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "gift-note" }, { children: (0, jsx_runtime_1.jsx)(GiftNoteOptions_1.default, { lineItem: lineItem }) }))] })) })));
}
exports.default = StandardLineItem;
//# sourceMappingURL=data:application/json;base64,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